import { createGlobalStyle } from 'styled-components';
import { formSpin } from './FormStyles';

const GlobalStyle = createGlobalStyle`
  ::selection {
    background: ${props => props.theme.primary};
    color: white;
  }
  body {
    font-family: 'Roboto', sans-serif;
    line-height: 1.625;
    color: ${props => props.theme.gray800};
    letter-spacing: .25px;
    &::before {
      content: '';
      transition: background-color .2s;
    }
    &.mobile-nav-open {
      overflow: hidden;
      &::before {
        content: '';
        position: fixed;
        width: 100%;
        height: 100vh;
        background: rgba(0,0,0,.5);
        display: block;
        z-index: 10;
      }
    }
  }
  section {
    padding: 40px 0;
    ${props => props.theme.media.md} {
    padding: 60px 0;
    }
  }
  .center-content {
    text-align: center;
  }
  a {
    text-decoration: none;
    color: ${props => props.theme.primary};
    &:hover {
      text-decoration: underline;
    }
  }
  p, ul {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.8;
  }
  h1 {
    font-weight: 100;
    margin: 0 0 1em;
    font-size: 2rem;
    text-align: center;
    line-height: 1.375;
    ${props => props.theme.media.sm} {
      font-size: 2.5rem;
    }
    ${props => props.theme.media.md} {
      font-size: 3rem;
    }
    ${props => props.theme.media.lg} {
      font-size: 3.5rem;
    }
  }
  h2 {
    font-size: 1.875rem;
    font-weight: 100;
    margin: 0 0 1em;
    text-align: center;
    line-height: 1.3em;
    ${props => props.theme.media.sm} {
      font-size: 2rem;
    }
    ${props => props.theme.media.md} {
      font-size: 2.5rem;
    }
    ${props => props.theme.media.lg} {
      font-size: 3rem;
    }
  }
  h3 {
    font-size: 1.375rem;
    font-weight: 300;
    margin: 0 0 1em;
    ${props => props.theme.media.md} {
      font-size: 1.5rem;
    }
    ${props => props.theme.media.lg} {
      font-size: 1.625rem;;
    }
  }
  h2 + .sub-header {
    margin-top: -1em;
  }
  a {
    transition: all .2s;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  svg {
    max-width: 100%;
  }
  .sub-header {
    font-size: 1rem;
    font-weight: 300;
    text-align: center;
    margin: 0 0 2em;
    ${props => props.theme.media.md} {
      font-size: 1.375rem;
    }
  }
  .gray-bg {
    background: ${props => props.theme.gray100};
  }
  .inverted-bg {
    background: ${props => props.theme.gray800};
    color: white;
  }

  .btn {
    padding: 13px 18px;
    min-width: 190px;
    text-transform: uppercase;
    font-size: 1.125rem;
    font-weight: 400;
    letter-spacing: .5px;
    line-height: 1;
  }
  .btn-sm {
    min-width: auto;
    padding: 0.625rem 1.25rem;
    font-size: .8125rem;
    border-radius: .2rem;
  }
  &.btn-clear {
    background: transparent;
    color: white;
    border: 1px solid white;
    &:hover {
      background: white;
      color: ${props => props.theme.gray800};
    }
  }
  &.btn-primary-clear {
    background: transparent;
    color: ${props => props.theme.primary};
    border: 1px solid ${props => props.theme.primary};
    font-weight: 500;
    &:hover {
      background: ${props => props.theme.primary};
      color: white;
    }
  }
  &.btn-play {
    &::after {
      content: '';
      width: 18px;
      height: 18px;
      background: url('/static/icon-play.svg') no-repeat 50%;
      background-size: 18px 18px;
      vertical-align: bottom;
      margin-left: 12px;
      display: inline-block;
    }
    &:hover {
      &::after {
        background-image: url('/static/icon-play-dark.svg');
      }
    }
  }
  .input-lg {
    ${props => props.theme.media.md} {
      height: 78px;
      font-size: 1.25rem;
    }
  }

  form.is-loading {
    position: relative;
    input {
      pointer-events: none;
      user-select: none;
    }
    &::before {
      position: absolute;
      content: '';
      top: -0;
      left: -0;
      background: rgba(255, 255, 255, 0.8);
      width: 100%;
      height: 100%;
      z-index: 100;
    }
    &::after {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      margin: -1.5em 0em 0em -1.5em;
      width: 3em;
      height: 3em;
      animation: ${formSpin} 0.6s linear;
      animation-iteration-count: infinite;
      border-radius: 50%;
      border-color: ${props => props.theme.primary} rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1)
        rgba(0, 0, 0, 0.1);
      border-style: solid;
      border-width: 0.2em;
      box-shadow: 0px 0px 0px 1px transparent;
      visibility: visible;
      z-index: 101;
    }
  }
  .form-control:disabled, .form-control[readonly] {
    color: ${props => props.theme.gray400};
    background: ${props => props.theme.gray100};
    user-select: none;
  }
`;

export default GlobalStyle;
